<h3>{{ label }}</h3>

<div class="lane" #lane>
  <button
    *ngIf="moreLeftSide && _functies.length > maxCardsShown && !isMobile"
    (click)="scrollToTheLeft()"
    class="lane__previous"
  >
    <mat-icon class="material-icons"> keyboard_arrow_left </mat-icon>
  </button>

  <button
    *ngIf="moreRightSide && _functies.length > maxCardsShown && !isMobile"
    (click)="scrollToTheRight()"
    class="lane__next"
  >
    <mat-icon class="material-icons"> keyboard_arrow_right </mat-icon>
  </button>

  <div #laneContainer class="lane__container">
    <div class="lane__item">
      <ng-container *ngIf="mode === 'functie'">
        <ng-container *ngIf="_functies.length > 0; else noFuncties">
          <app-functie-card
            *ngFor="let functie of _functies"
            (select)="handleSelect($event)"
            (preview)="handleSelect($event)"
            (favorite)="handleFavoriteClick($event, true)"
            [mode]="functieCardMode"
            [functie]="functie"
            [showMatchPercentage]="showMatchPercentage"
            [showActions]="false"
          >
          </app-functie-card>
        </ng-container>

        <ng-template #noFuncties>
          <h3>{{ "lane.noFuncties" | content }}</h3>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="mode === 'opleiding'">
        <ng-container *ngIf="opleidingen.length > 0; else noOpleidingen">
          <app-opleiding-card
            *ngFor="let opleiding of opleidingen"
            (favorite)="handleFavoriteClick($event, false)"
            [mode]="opleidingCardMode"
            [opleiding]="opleiding"
            [showMatchPercentage]="showMatchPercentage"
          >
          </app-opleiding-card>
        </ng-container>

        <ng-template #noOpleidingen>
          <h3>{{ "lane.noOpleidingen" | content }}</h3>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
